import React from 'react';
import { FormGroup } from '@mui/material';

import ContactFormField from '../ContactFormField/ContactFormField';
import { UseContactFormReturn } from '../hooks/useContactForm';

import css from './ContactFormFields.module.css';

type ContactFormFieldsProps = UseContactFormReturn;

const ContactFormFields: React.FC<ContactFormFieldsProps> = ({
  fieldsByFieldset,
  getSibilingFieldByName,
  isFieldNextToAnother,
  onSelectionChange,
  errors,
  trigger,
  control
}: ContactFormFieldData) => fieldsByFieldset?.map((field: ContactFormFieldData) => {
  if (!field) {
    return null;
  }

  const nextField = getSibilingFieldByName?.(field?.name || '', fieldsByFieldset);

  // render sibling fields together
  if (nextField) {
    return (
      <FormGroup key={`${field?.name}-${nextField?.name}`} className={css.group} row>
        <ContactFormField
          field={field}
          errors={errors}
          trigger={trigger}
          control={control}
          onSelectionChange={onSelectionChange}
        />
        <ContactFormField
          field={nextField}
          errors={errors}
          trigger={trigger}
          control={control}
          onSelectionChange={onSelectionChange}
        />
      </FormGroup>
    );
  }

  // render only fields with no siblings
  return !isFieldNextToAnother?.(field?.name || '') ? (
    <ContactFormField
      key={field?.id}
      field={field}
      errors={errors}
      trigger={trigger}
      control={control}
      onSelectionChange={onSelectionChange}
    />
  ) : null;
});

export default ContactFormFields;
